import React, { useState } from 'react';
import { useLocation, useNavigate } from '@reach/router';
import { FormLabel, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';
import { Redux, Slices } from 'spwa-ui-library';
import { v4 as uuidv4 } from 'uuid';
import ClassNames from 'classnames';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { productClickGA, productListingCustomizeClickGA } from 'spwa-ui-library/esm/utils/helperGA';
import css from './index.module.scss';

const { useSelector, useDispatch } = Redux;

const { getClusterId, getVariantConfig } = Slices.configSlice;
const { selectDesktop } = Slices.appSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectProductEntities, selectProductById } = Slices.productSlice;
const {
  productSizeChange,
  addProductToTempCustomize,
  selectCustomizeProductById,
  selectTempProductById,
  selectCustomizeProductFilterById,
} = Slices.tempCartSlice;
const { findItem } = Slices.cartSlice;

function ProductVariations({
  productRoute,
  productObj,
  currency,
  categoryObj,
  position,
  mainProductId,
  isBundleItem,
  stepId,
}) {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const locationSearch = new URLSearchParams(location.search);
  const pathSegments = location?.pathname.split('/');
  const isIncludeDeals = ['deals', 'العروض'].includes(pathSegments[2]);

  const isDesktop = useSelector(selectDesktop);
  const productsMap = useSelector(selectProductEntities);
  const variationConfig = useSelector(getVariantConfig);
  const tempProduct = useSelector((state) => selectTempProductById(state, productObj.id));
  let tempItems = useSelector((state) => state.tempCart.data.items);
  let tempCart = useSelector((state) => state.tempCart);
  const customizeProduct = useSelector((state) =>
    selectCustomizeProductFilterById(state, isBundleItem ? mainProductId : productObj.id)
  );
  const findCartItem = useSelector((state) => findItem(state, productObj.id));
  const mainTempCart = useSelector((state) => selectTempProductById(state, mainProductId));
  const mainCustomize = useSelector((state) => selectCustomizeProductById(state, mainProductId));
  const isCustomizedValue = useSelector((state) =>
    selectCustomizeProductById(state, productObj.id)
  );

  const productValue = useSelector((state) => selectProductById(state, productObj.id));
  const productBundle = useSelector((state) => selectProductById(state, mainProductId));

  let productCustomizationPayload, productVariants;

  if (isBundleItem) {
    let productInfo = Object.values(mainTempCart?.['bundle'] || {})?.find(
      (prod) => Object.keys(prod[productObj.id] || {}).length > 0
    );
    productVariants = productInfo?.[productObj.id]?.variants;

    productCustomizationPayload = mainTempCart?.['bundle']?.[stepId]?.[productObj.id];
  } else {
    let isProductInCart = findCartItem?.length > 0;
    if (isProductInCart) {
      productVariants = tempProduct?.variants;
    }

    productCustomizationPayload = isCustomizedValue || tempProduct;
  }

  const CustomID = useState(uuidv4());
  let newPro = {
    ...productObj,
    UUID: CustomID[0],
  };

  const handleNavigation = (e) => {
    e.preventDefault();
    productListingCustomizeClickGA(productObj, categoryObj.name, position);
    productClickGA(productObj, currency, categoryObj.name);
    navigate(productRoute, {
      state: {
        oldLocation: JSON.parse(JSON.stringify(location)),
        description: intl.formatMessage({ id: 'customize_your_meals' }),
      },
    });
  };

  const handleVariationChange = (id, itm, productObj) => {
    const productInfo = { ...productValue };
    let isCustomized = tempItems.filter(
      (item) => item?.id == (isBundleItem ? mainProductId : productObj.id)
    );

    if (!isBundleItem) {
      isCustomized = tempCart.customize.items.filter(
        (item) => item?.id == (isBundleItem ? mainProductId : productObj.id)
      );
    }

    let chosedItem = null;

    if (isBundleItem) {
      let variations = {};
      if (
        isCustomized?.length > 0 &&
        isCustomized[0]?.['bundle']?.[stepId]?.[productObj.id]?.['variants']
      ) {
        variations = JSON.parse(
          JSON.stringify(isCustomized[0]?.['bundle']?.[stepId]?.[productObj.id]?.['variants'])
        );
      } else {
        // eslint-disable-next-line no-unused-expressions
        productObj?.variants.forEach((variant) => {
          const selectedVariation = variant?.options?.filter((option) => option?.isSelected == 1);
          if (selectedVariation.length) {
            variations[variant.id] = selectedVariation[0].id;
          }
        });
      }
      variations[itm.id] = id;
      if (!isCustomized?.length) {
        dispatch(
          addProductToTempCustomize({
            productType: productValue.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productValue,
            data: { ...productValue, category: categoryObj.id, noIncrement: true },
          })
        );
      }

      // get default items
      let defaultItems = {},
        variationArray = [-1, -1, -1],
        currentProductVariation = null;

      Object.values(variations || {}).forEach((variation, idx) => {
        variationArray[idx] = variation;
      });

      currentProductVariation = productObj?.items?.find((item) => {
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (item[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      for (let step of currentProductVariation?.steps || []) {
        let optionObj = {};
        for (let option of step?.options || []) {
          if (option?.subOptions) {
            let defaultSubOption = option?.subOptions?.find((subOption) => subOption?.default == 1);
            if (defaultSubOption) {
              optionObj[option.id] = { qty: 1 };
            }
          } else {
            if (option?.default) {
              optionObj[option.id] = { qty: 1 };
            }
          }
        }
        if (Object.values(optionObj || {}).length > 0) {
          defaultItems[step.id] = optionObj;
        }
      }

      dispatch(
        productSizeChange({
          chosedItem,
          mainId: productObj.UUID,
          optionId: variations,
          variantId: itm.id,
          defaultItems,
          isBundleItem,
          mainProductId,
          id: productObj.id,
          stepId,
          notAdded: true,
          productPayload: productBundle,
        })
      );
    } else {
      productInfo &&
        productInfo.items &&
        productInfo.items.length > 0 &&
        productInfo.items.forEach((val) => {
          let selectedId = val.id ? val.id : val;
          const itemObj = productsMap[selectedId];
          if (itemObj.sel1Value === itm.id) {
            chosedItem = itemObj;
          }
        });

      if (!isCustomized.length || isCustomized?.[0]?.items) {
        // addCustomize;
        dispatch(
          addProductToTempCustomize({
            productType: newPro.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: newPro.id,
            data: {
              ...newPro,
              category: categoryObj.id,
              noIncrement: true,
              price: newPro?.price,
            },
          })
        );
      }

      // get default items
      let defaultItems = {},
        variationArray = [-1, -1, -1],
        currentProductVariation = null;

      let newVariants = {};

      for (let variant of productInfo?.variants || []) {
        let variantId = variant.id;
        let selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
        if (selectedOption) {
          newVariants[variantId] = selectedOption?.id;
        }
      }

      newVariants[itm.id] = id;

      Object.values(newVariants || {}).forEach((variant, index) => {
        variationArray[index] = variant;
      });

      currentProductVariation = productInfo?.items?.find((itemInfo) => {
        let item;
        if (!itemInfo?.id) {
          item = productsMap[itemInfo];
        } else {
          item = itemInfo;
        }
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (item[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      if (!currentProductVariation?.id) {
        currentProductVariation = productsMap[currentProductVariation];
      }

      for (let step of currentProductVariation?.steps || []) {
        let optionObj = {};
        for (let option of step?.options || []) {
          if (option?.subOptions) {
            let defaultSubOption = option?.subOptions?.find((subOption) => subOption?.default == 1);
            if (defaultSubOption) {
              optionObj[option.id] = { qty: 1 };
            }
          } else {
            if (option?.default) {
              optionObj[option.id] = { qty: 1 };
            }
          }
        }
        if (Object.values(optionObj || {}).length > 0) {
          defaultItems[step.id] = optionObj;
        }
      }

      const actualPrice =
        currentProductVariation?.price >= 0
          ? currentProductVariation?.price
          : currentProductVariation?.specialPrice || currentProductVariation?.originalPrice;

      console.log('111111111111');
      dispatch(
        productSizeChange({
          chosedItem,
          mainId: productObj.UUID,
          defaultItems,
          optionId: id,
          variantId: itm.id,
          isBundleItem,
          mainProductId,
          newPrice: actualPrice,
          id: productObj.id,
          stepId,
          notAdded: true,
          productPayload: newPro,
        })
      );
    }
  };

  const hideCustomize =
    productObj.typeId === 'simple' || productObj.typeId === 'configurable' ? false : true;

  let selectedVariants = [];
  if (productCustomizationPayload || productVariants) {
    selectedVariants = Object.values(
      productVariants || productCustomizationPayload?.variants || {}
    );
  } else {
    const defaultVariationArray = new Array(3).fill(-1);
    for (let variation of productObj?.variants || []) {
      const selectedOption = variation?.options?.find((option) => option?.isSelected == 1)?.id;
      defaultVariationArray[variation?.selIndex - 1] = selectedOption;
    }
    selectedVariants = defaultVariationArray;
  }

  for (let i = 0; i < 3; i++) {
    if (!selectedVariants[i]) selectedVariants[i] = -1;
  }

  // check is button needs to be disabled
  let shouldDisabledButton;
  if (isBundleItem) {
    const currentStepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
    const currentStepProductsCount =
      Object.values(mainTempCart?.['bundle']?.[stepId] || {})?.reduce((totalQty, product) => {
        return totalQty + (product?.notAdded ? 0 : product?.qty || 1);
      }, 0) || 0;

    if (currentStepProductsCount >= (currentStepInfo?.maximum || 1)) {
      shouldDisabledButton = true;
    } else {
      shouldDisabledButton = false;
    }
  }

  return (
    <>
      {!hideCustomize || !isDesktop ? (
        productObj?.variants?.length ? (
          <div className={ClassNames(css.variationContainer)}>
            {Array.isArray(productObj.variants) &&
              productObj?.bundleTypeId != 'bundle_group' &&
              productObj.variants.map((variation, idx) => {
                const defaultVariation = variation.options.find((option) => option?.isSelected == 1)
                  ?.id;

                let allProducts = [];
                for (let step of Object.values(mainTempCart?.['bundle'] || {})) {
                  for (let [pId, pObj] of Object.entries(step)) {
                    allProducts = [...allProducts, { ...pObj, id: pId }];
                  }
                }

                let matches = allProducts?.filter((item) => item?.id == productObj?.id);
                let actualMatches = [];
                for (let match of matches) {
                  let doesVariationExist = true;
                  for (let [variantId, selectedVariant] of Object.entries(match?.variants || {})) {
                    // check if this combo exists in productObj or not
                    let currentVariation = productObj?.variants?.find((v) => v.id == variantId);
                    let currentSelectedVariation = currentVariation?.options?.find(
                      (cv) => cv.id == selectedVariant
                    );

                    if (!currentSelectedVariation) {
                      doesVariationExist = false;
                    }
                  }

                  if (doesVariationExist) {
                    actualMatches.push(match);
                  }
                }
                matches = actualMatches;

                const selectedVariation =
                  // productVariants?.[variation.id] ||
                  (isBundleItem
                    ? mainTempCart?.['bundle']?.[stepId]?.[productObj.id]?.['variants']?.[
                        variation.id
                      ]
                    : productCustomizationPayload?.['variants']?.[variation.id]) ||
                  matches[matches.length - 1]?.['variants']?.[variation.id] ||
                  defaultVariation;

                const allVariations = productCustomizationPayload
                  ? Object.values(
                      selectedVariants ||
                        productCustomizationPayload?.['variants'] ||
                        productCustomizationPayload?.['bundle']?.[stepId]?.[productObj.id] ||
                        {}
                    )
                  : [];

                // check for second variation, i.e. crust
                let filteredVariationIds = [];
                if (idx > 0 && allVariations.length && productObj?.items?.[0]?.id) {
                  filteredVariationIds =
                    productObj?.items
                      ?.filter((item) => item[`sel1Value`] == allVariations[0])
                      ?.map((item) => item.sel2Value) || [];
                }
                // debugger;
                const variationInfo = variationConfig?.find(
                  (v) => v.orientation == variation.orientation
                );

                return (
                  <FormLabel
                    key={`form-${variation?.subtitle}_${variation?.id}_${productObj?.id}`}
                    className={css.selectForm}
                  >
                    <InputLabel id={`${variation.subtitle}_${idx}`}>
                      {variation.subtitle}
                    </InputLabel>
                    <Select
                      className={css.select}
                      id={`${variation.subtitle}_${idx}`}
                      labelId={`${variation.subtitle}_${idx}`}
                      label={variation.subtitle}
                      value={selectedVariation}
                      renderValue={(selected) => {
                        return variation?.options.find((x) => x.id == selected)?.title;
                      }}
                      disabled={(variation?.options?.length || 0) < 2 || shouldDisabledButton}
                      onChange={(event, value) =>
                        handleVariationChange(event.target.value, variation, productObj)
                      }
                      disableUnderline={true}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        transformOrigin: {
                          vertical: 'top',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                      }}
                    >
                      {variation.options.map((option, index) => {
                        let currentProductVariation;
                        let description = variationInfo?.variations?.find((v) =>
                          intl.locale == 'en'
                            ? v[`key_${intl.locale}`]?.toLowerCase() == option?.title?.toLowerCase()
                            : v[`key_${intl.locale}`] == option?.title
                        )?.[`subtitle_${intl.locale}`];
                        let currentVariation = [...selectedVariants];
                        currentVariation[variation?.selIndex - 1] = option?.id;

                        if (!isBundleItem) {
                          currentProductVariation = Object.values(productObj?.items || [])?.find(
                            (item) => {
                              let currentProductItem = productsMap?.[item?.id || item];

                              let isVariantSame = true;
                              currentVariation.forEach((variant, index) => {
                                if (
                                  variant > -1 &&
                                  currentProductItem?.[`sel${index + 1}Value`] != variant
                                ) {
                                  isVariantSame = false;
                                }
                              });

                              return isVariantSame;
                            }
                          );
                        } else {
                          let mainProduct = productsMap[mainProductId];

                          const stepInfo = mainProduct?.steps?.find((step) => step?.id == stepId);

                          const productInfo = stepInfo?.options?.find(
                            (option) => option?.id == productObj.id
                          );

                          currentProductVariation = Object.values(
                            productInfo?.items ||
                              (productObj?.bundleTypeId?.includes('bundle')
                                ? []
                                : productObj?.items)
                          )?.find((item) => {
                            let isVariantSame = true;
                            currentVariation.forEach((variant, index) => {
                              if (
                                (productsMap?.[item?.id || item] || item)?.[
                                  `sel${index + 1}Value`
                                ] != variant
                              ) {
                                isVariantSame = false;
                              }
                            });
                            return isVariantSame;
                          });
                        }

                        if (!currentProductVariation?.id)
                          currentProductVariation = productsMap[currentProductVariation];

                        let optionPrice =
                          currentProductVariation?.price >= 0
                            ? currentProductVariation?.price
                            : currentProductVariation?.specialPrice ||
                              currentProductVariation?.originalPrice;

                        return (
                          <MenuItem
                            id={`${option.title}_${index}`}
                            disabled={
                              (idx == 0 &&
                                filteredVariationIds.length &&
                                !filteredVariationIds.includes(option?.id)) ||
                              optionPrice == undefined
                                ? true
                                : false
                            }
                            value={option.id}
                          >
                            <div className={css.variationOption}>
                              <img src={option?.assets?.[0]?.src} alt={option?.assets?.[0]?.alt} />
                              <div className={css.optionInfo}>
                                <span className={css.optionTitle}>
                                  <span className={css.optionTitleLine1}>{option.title}</span>
                                  {description && (
                                    <span
                                      className={css.optionTitleLine2}
                                    >{`(${description})`}</span>
                                  )}
                                </span>
                                {optionPrice == undefined ? (
                                  <span className={css.notAvailable}>
                                    <FormattedMessage
                                      id="not_available"
                                      defaultMessage="Not Available"
                                    />
                                  </span>
                                ) : (
                                  optionPrice > 0 && (
                                    <span className={css.optionPrice}>
                                      {`${decimalChecker(optionPrice)} ${currency}`}
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormLabel>
                );
              })}
          </div>
        ) : (
          ''
        )
      ) : (
        ''
      )}
      {productObj.bundleTypeId == 'bundle' && (
        <span className={css.priceSpan}>
          <span
            className={ClassNames(
              css.specialPrice,
              {
                [css.priceColor]: isIncludeDeals,
                [productObj.specialPrice != productObj.originalPrice
                  ? css.dealCaseSpclPrice
                  : css.dealCasePrice]: !isDesktop && isIncludeDeals,
                [productObj.specialPrice ? css.dealCaseSpclPrice : '']:
                  !isDesktop && isIncludeDeals,
              },
              {
                [!hideCustomize ? '' : css.mobilePriceView]: !hideCustomize && !isDesktop,
              }
            )}
          >
            {decimalChecker(productObj.specialPrice)}
            <span> {currency}</span>
          </span>
          {productObj.specialPrice != productObj.originalPrice && (
            <span
              className={ClassNames(
                css.strikeThruPrice,
                { [css.strikePriceAr]: intl.locale === 'ar' },
                { [css.strikePriceDealCase]: intl.locale === 'ar' && isIncludeDeals },
                { [css.specialPriceDealCase]: intl.locale === 'ar' && isIncludeDeals },
                {
                  [css.priceColor]: isIncludeDeals,
                  [productObj.specialPrice != productObj.originalPrice
                    ? ClassNames(css.dealCasePrice, css.dealCaseSpclPrice)
                    : css.dealCasePrice]: !isDesktop && isIncludeDeals,
                },
                {
                  [!hideCustomize ? '' : css.mobilePriceView]: !hideCustomize && !isDesktop,
                }
              )}
            >
              {decimalChecker(productObj.originalPrice)} {currency}
            </span>
          )}
        </span>
      )}
    </>
  );
}

export default ProductVariations;
